import ModelManager from "../../../../ModelManager";
import getFactory from "../../../actions/getFactory";

export default recordId => modelManager => () => getFactory(ModelManager.MODEL.RECORD, modelManager)(recordId);



// WEBPACK FOOTER //
// ./src/contexts/userContext/schemaContext/recordContext/getRecordContextFactory.js